'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var LOAD_BASE = function LOAD_BASE(name) {
  return Promise.reject(new Error("No base found for \"".concat(name, "\"")));
};

var Multibases =
/*#__PURE__*/
function () {
  function Multibases(options) {
    _classCallCheck(this, Multibases);

    this._basesByName = {};
    this._basesByPrefix = {};
    this._loadBase = options.loadBase || LOAD_BASE;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = options.bases[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var base = _step.value;
        this.addBase(base);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  _createClass(Multibases, [{
    key: "addBase",
    value: function addBase(base) {
      if (this._basesByName[base.name] || this._basesByPrefix[base.prefix]) {
        throw new Error("Codec already exists for codec \"".concat(base.name, "\""));
      }

      this._basesByName[base.name] = base;
      this._basesByPrefix[base.prefix] = base;
    }
  }, {
    key: "removeBase",
    value: function removeBase(base) {
      delete this._basesByName[base.name];
      delete this._basesByPrefix[base.prefix];
    }
  }, {
    key: "getBase",
    value: function () {
      var _getBase = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(nameOrPrefix) {
        var base;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._basesByName[nameOrPrefix]) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this._basesByName[nameOrPrefix]);

              case 2:
                if (!this._basesByPrefix[nameOrPrefix]) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", this._basesByPrefix[nameOrPrefix]);

              case 4:
                _context.next = 6;
                return this._loadBase(nameOrPrefix);

              case 6:
                base = _context.sent;

                if (this._basesByName[base.name] == null && this._basesByPrefix[base.prefix] == null) {
                  this.addBase(base);
                }

                return _context.abrupt("return", base);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getBase(_x) {
        return _getBase.apply(this, arguments);
      }

      return getBase;
    }()
  }, {
    key: "listBases",
    value: function listBases() {
      return Object.values(this._basesByName);
    }
  }]);

  return Multibases;
}();

exports.Multibases = Multibases;